import {Logger, PubSub} from '@mamdev/cad.static-next-lib';
import Script from '../../ts/services/script';
import UrlPath from '../../ts/services/url-path';

interface IframeMessage {
  message: {
    trigger: string;
    method: string;
  };
}

/**
 * Wrapper for using iframeResizer
 * https://github.com/davidjbradshaw/iframe-resizer
 */
class IframeHandler {
  private initialized = false;

  initialize() {
    if (this.initialized) return;
    this.initialized = true;

    this.loadExternalJS();
  }

  /** lazyload iFrameResizer lib */
  loadExternalJS() {
    if (!window.iFrameResize) {
      Script.fetch(UrlPath.sn + '/iframeResizer.min.js').then(() => {
        this.log('iFrameResizer lazyloaded');
        this.applyResizerToIframe();
      }, reason => {
        this.log('failed to load: ' + reason);
      });
    } else {
      this.applyResizerToIframe();
    }
  }

  applyResizerToIframe() {
    const IFrameSelector = '.autoresize';
    const iFrameOptions = {
      'log': false,
      'checkOrigin': false,
      'enablePublicMethods': true,
      'heightCalculationMethod': 'bodyOffset',
      'messageCallback': function(iframeMessage: IframeMessage) {
        if ((iframeMessage.message.trigger === 'iFrame')
          && ((iframeMessage.message.method === 'countWAPI') || (iframeMessage.message.method === 'adRefresh') || (iframeMessage.message.method === 'scrollup'))) {
          window.postMessage(iframeMessage.message, '*');
        }
      }
    };

    window.iFrameResize(iFrameOptions, IFrameSelector);

    // CADNPCA-7280
    PubSub.subscribe('externalembed:iframeLoad', () => {
      if (window.iFrameResize) {
        window.iFrameResize(iFrameOptions, IFrameSelector);
      }
    });
  }

  log(message: string) {
    Logger.log('iframeHandler', message);
  }
}

export default new IframeHandler();
